var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelsiusAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6C8.32843 6 9 6.67157 9 7.5C9 8.32843 8.32843 9 7.5 9ZM17.8501 15.9217C17.2636 17.2086 15.8625 18 14.0835 18C11.2943 18 9.6 16.1984 9.6 13.2C9.6 10.208 11.3269 8.4 14.0313 8.4C15.7908 8.4 17.1528 9.17212 17.798 10.5105C17.9283 10.755 17.9935 11.0059 17.9935 11.2375C17.9935 11.7458 17.6481 12.074 17.1268 12.074C16.6836 12.074 16.4034 11.881 16.1884 11.4306C15.7583 10.4847 14.9893 10.0086 14.0509 10.0086C12.5651 10.0086 11.6071 11.2375 11.6071 13.1936C11.6071 15.1753 12.5521 16.3979 14.0574 16.3979C15.0479 16.3979 15.7908 15.9539 16.2144 15.0209C16.4164 14.5834 16.6641 14.4097 17.0811 14.4097C17.6351 14.4097 18 14.7571 18 15.2719C18 15.4906 17.9479 15.6965 17.8501 15.9217Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelsiusAlt);
export default __webpack_public_path__ + "static/media/celsius-alt.fe030167a0b4aa8d8d32df7850a5b190.svg";
export { ForwardRef as ReactComponent };